import React, {Component} from "react";

export const RADIO_BUTTON_SELECTED = "selected";
export const RADIO_BUTTON_NOT_SELECTED = "not_selected";
export const RADIO_BUTTON_DISABLED = "disabled";

export class RadioButton extends Component {
    constructor(props) {
        super(props);
        this.state = {
            status: this.props.status
        };
    }

    componentDidUpdate(prevProps) {
        if (this.props.status !== prevProps.status) {
            this.setState({
                status: this.props.status
            });
        }
    }

    handleClick = (event) => {
        event.preventDefault();

        // Disable interaction if the state is disabled
        if (this.state.status === RADIO_BUTTON_DISABLED) {
            return;
        }

        // Toggle between selected and not_selected when clicked
        this.setState(prevState => {
            if (prevState.status === RADIO_BUTTON_NOT_SELECTED) {
                return { status: RADIO_BUTTON_SELECTED };
            } else {
                return { status: RADIO_BUTTON_NOT_SELECTED };
            }
        });

        if(this.props.onActivation !== undefined)
            this.props.onActivation();
    };

    render () {
        const { status } = this.state;

        return <div className={`radio-button ${status}`} onClick={this.handleClick}></div>;
    }
}
